import { IEidosModuleAPIConfiguration } from '@app/core/config/environment.interface'
import { SafeBaseObject } from '@app/core/models/base-object.models'
import { DateTime } from 'luxon'
import { ReservationActionBooking } from './reservation-permission.model'
import { ReservationConnectedSuite } from '@app/reservation/models/res-cruise-availability.models'
export interface IReservationApiGetSuppliers {
  SupplierID?: number
  SupplierName?: string
  AllSuppliers?: string
  ServiceTypeID?: number
  companyID_OVERWRITE?: number
  PageSize?: number
}

export class ResVilla extends SafeBaseObject {
  static INVALID_VILLAS_ID = 0

  villaID = ResVilla.INVALID_VILLAS_ID
  name = ''
  shortName = ''
  cityID = 0
  city = ''
  supplierID = 0
  supplierName = ''
  description = ''
  currencyCod = ''
  startDate = DateTime.invalid('empty')
  endDate = DateTime.invalid('empty')
  webSiteVisibilityFrom = DateTime.invalid('empty')
  webSiteVisibilityTo = DateTime.invalid('empty')
  isReservationOpen = false
  isWebSiteOpen = false

  internalType = 'villa'

  constructor(data?: any) {
    super()
    this.updateData(data)
  }

  override updateData(data: any): void {
    if (!data) return
    super.updateData(data)
  }

  get isValid(): boolean {
    return this.villaID !== ResVilla.INVALID_VILLAS_ID
  }
}
export class ResVillaDetails extends SafeBaseObject {
  villaDetails?: ResVillaSetupDetails
  villaDatePrices: ResVillaSetupDatePrices[] = []

  constructor(data?: any) {
    super()
    this.updateData(data)

    this.villaDetails = new ResVillaSetupDetails(data.DT0[0])
    data.DT1.forEach((villaDatePrice: any) => {
      const mappedVillaDatePrice = new ResVillaSetupDatePrices(villaDatePrice)
      this.villaDatePrices.push(mappedVillaDatePrice)
    })
  }
}

export class ResVillaSetupDetails extends SafeBaseObject {
  villaID = 0
  name = ''
  shortName = ''
  description = ''
  maxOccupancy = 0
  bedrooms = 0
  cityID = 0
  city = ''
  currencyCod = ''
  startDate = DateTime.invalid('empty')
  endDate = DateTime.invalid('empty')
  webSiteVisibilityFrom = DateTime.invalid('empty')
  webSiteVisibilityTo = DateTime.invalid('empty')
  supplierID = 0
  supplierName = ''

  constructor(data?: any) {
    super()
    this.updateData(data)
  }
}

export class ResVillaSetupDatePrices extends SafeBaseObject {
  villaPriceID = 0
  date = DateTime.invalid('empty')
  duration = 0
  sellingPrice = 0
  currency = ''
  priceTypeID = 0
  priceTypeName = ''
  startDate = DateTime.invalid('empty')
  endDate = DateTime.invalid('empty')
  isReservationOpen = false
  isWebSiteOpen = false

  constructor(data?: any) {
    super()
    this.updateData(data)
  }
}

export interface IReservationModuleAPIConfiguration extends IEidosModuleAPIConfiguration {
  /**
   * shared key for aquire key
   *
   * @type {string}
   * @memberof IReservationModuleAPIConfiguration
   */
  shared?: string;
  /**
   * Payment callback API URL
   *
   * @type {string}
   * @memberof IReservationModuleAPIConfiguration
   */
  paymentCallbackAPI?: string;
  /**
   * Send AMEX data to gateway payment
   *
   * @type {string}
   * @memberof IReservationModuleAPIConfiguration
   */
  useAmexData: boolean;
  /**
   * Payment API URL
   *
   * @type {string}
   * @memberof IReservationModuleAPIConfiguration
   */
  paymentAPI: string;
  paymentGateway: string;
  paymentGatewayCallback: string;
  usePaymentGateway: boolean;
  /**
   * Ticketing API URL
   *
   * @type {string}
   * @memberof IReservationModuleAPIConfiguration
   */
  ticketingUrl: string;
  /**
   * Frame ticketing path
   *
   * @type {string}
   * @memberof IReservationModuleAPIConfiguration
   */
  frameTicketingPath: string;
  /**
   * Send email logic app URL
   *
   * @type {string}
   * @memberof IReservationModuleAPIConfiguration
   */
  sendEmailUrl: string;
}

export interface IResVillaAvailabilityParams {
  VillaID: number
  Currency?: string
  PriceTypeID?: number
  DateFrom?: DateTime
  DateTo?: DateTime
  MonthList?: string
}

export class ResVillaAvailability extends SafeBaseObject {
  villaID!: number
  ship!: string
  paxNum!: number
  description!: string
  dateFrom = DateTime.local()
  dateTo = DateTime.local()
  duration!: number
  durationUDM!: string
  sellingPrice!: number
  currency!: string
  priceTypeID!: number
  priceTypeName!: string

  formattedDateFrom!: string
  formattedDateTo!: string
  formattedSellingPrice!: string

  constructor(data: Partial<ResVillaAvailability>) {
    super()
    this.updateData(data)
    this.formatDateTimeProperties()
  }

  get is7Days(): boolean {
    return this.duration === 7
  }

  get is14Days(): boolean {
    return this.duration === 14
  }
}
export interface IReservationApiDepartment {
  DepartmentID: number
  DepartmentName: string
}

export interface IReservationGeoTree {
  DestinationID: number;
  DestinationTypeName: string;
  DestinationShortName: string;
  DestinationName: string;
  CountryID: number;
  CountryCod: string;
  Country: string;
  CityID: number;
  CityCod: string;
  PortCod: string;
  City: string;
  Latitude: number;
  Longitude: number;
  GeoTreeID: number;
  GeoTreeName: string;
  CompanyID: number;
}

export interface IResBookingActionCommand {
  action: ReservationActionBooking;
  sectionID?: number;
  actionParams: any[];
}

export interface IResBookingAction {
  id: string;
  icon?: string;
  caption: string;
  disabled: boolean;
  order: number;
  tooltip: string;
}

export interface IReservationUploadBlobResponse {
  fileId?: number;
  fileGuid?: string;
  fileName?: string;
}

export class ReservationUploadBlobResponse extends SafeBaseObject {
  fileId = 0;
  fileGuid = '';
  fileName = '';

  constructor(data: IReservationUploadBlobResponse) {
    super()
    this.updateData(data);
  }
}

export enum ResServiceSetupComponentTab {
  Suppliers = 'suppliers',
  ServiceTypes = 'service types',
  Services = 'services',
  ServicesOptions = 'services options',
  Options = 'options',
  ServicesInclusive = 'inclusive options',
  SequentialDiscount = 'seq. discount',
}

export class ResPkgBookingTravelDate extends SafeBaseObject {
  bkgID = 0
  bkgStatus = ''
  packageID = 0
  packageTravelDateID = 0
  guestsList: string[] = []
  voyageId = 0
  voyageID = 0
  voyageNumber = ''
  suiteID = 0
  suiteNo = ''
  suiteCategoryID = 0
  suiteCategoryCod = ''
  suiteCategory = ''
  guests = ''
  linkedBooking = ''

  constructor(data: any) {
    super()
    this.updateData(data)
  }
  override updateData(data: any): void {
    if (!data) return
    super.updateData(data)
    this.guestsList = this.guests.split(',')
  }
}

export class ResReceiptType extends SafeBaseObject {
  receiptTypeID = 0
  receiptTypeName = ''
  isCreditCard = false
  section = ''

  constructor(data?: any) {
    super()
    this.updateData(data)
  }

  get isPayment(): boolean {
    return ['all', 'payment'].includes(this.section.toLowerCase())
  }
  get isRefund(): boolean {
    return ['all', 'refund'].includes(this.section.toLowerCase())
  }
}
export class ResPackageAllocation extends SafeBaseObject {
  packageID = 0;
  packageName = '';
  childTag = '';
  travelStartDate = DateTime.invalid('empty');
  serviceID = 0;
  serviceName = '';
  serviceType = '';
  serviceTypeID = 0;
  optionID = 0;
  optionName = '';
  dateFrom = DateTime.invalid('empty');
  dateTo = DateTime.invalid('empty');
  initialAllotmentQTY = 0;
  onHoldAllotmentQTY = 0;

  constructor(data?: any) {
    super();
    this.updateData(data);
    this.formatDateTimeProperties()
  }
}

export interface IResApiPackageAllocations {
  PackageID?: number;
  PackageName?: string;
  PackageTravelDateID?: number;
  DateFrom?: DateTime;
  DateTo?: DateTime;
}

export class ResCheckInDay extends SafeBaseObject {
  checkInDayID = 0;
  checkInDay = '';

  constructor(data: any) {
    super()
    this.updateData(data)
  }
}

export class ResVillaPriceRange extends SafeBaseObject {
  cod = '';
  type = '';

  constructor(data: any) {
    super()
    this.updateData(data)
  }
}

export class ResVillaAirConditioning extends SafeBaseObject {
  cod = '';
  type = '';

  constructor(data: any) {
    super()
    this.updateData(data)
  }
}


export class ReservationSuiteAllocation extends SafeBaseObject {
  allocationbySuiteID = 0
  suiteCategoryCod = ''
  suiteCategory = ''
  suiteID = 0
  voyageID = 0
  embarkDate = DateTime.invalid('empy')
  debarkDate = DateTime.invalid('empy')
  companyID = 0
  companyName = ''
  packageID = 0
  packageName = ''
  packageTravelDateID = 0
  travelStartDate = DateTime.invalid('empy')

  shipID = 0
  shipCod = ''
  ship = ''

  deckID = 0;
  deckNumber = 0;
  deckName = ''

  suiteNo = ''
  suiteDisplay = ''
  suiteDisplayName = ''
  statusDescription = ''
  infoTooltipHtml = ''
  tooltip = ''

  displaySequence = 0

  isSelected = false
  isAllocated = false
  isBooked = false
  isStdHold = false
  isContractGroup = false
  isAda = false
  isDisabledEdit = false
  originalCompanyID = 0

  connectedSuite = new ReservationConnectedSuite()

  constructor(data?: any) {
    super()
    this.updateData(data)
  }

  override updateData(data: any): void {
    if (!data) return
    super.updateData(data)
    this.suiteDisplayName = this.suiteDisplay != '' ? this.suiteDisplay : this.suiteNo
    this.isAllocated = this.allocationbySuiteID > 0
    this.originalCompanyID = this.companyID
  }

}
export class ReservationSuiteAllocationManage {
  AllocationbySuiteID?: number
  VoyageID?: number
  CompanyID?: number
  PackageID?: number
  PackageTravelDateID?: number
  SuiteID?: number
  Status = ''
}
export class ReservationSuiteAllocationParams {
  PackageID = 0
  AllocSuite: ReservationSuiteAllocationManage[] = []
}

export class ResCompanyLight extends SafeBaseObject {
  companyID = 0
  company = ''

  constructor(data: any) {
    super()
    this.updateData(data)
  }
}

export class RescomLastWorkedBookingData {

}
export class ResLastWorkedBooking extends SafeBaseObject {
  company = ''
  creationDate = DateTime.invalid('empty')
  createdBy = ''
  bkgID = 0
  bkgName = ''
  bkgStatus = ''
  bkgCurrency = ''
  channel = ''
  agency = ''
  agentDirect = ''
  travelDate = DateTime.invalid('empty')
  duration = 0
  mainDestination = ''
  packageName = ''
  segment = ''
  subSegment = ''
  leadPassenger = ''
  totalCharge = 0
  cost = 0
  commission = 0
  margin = 0
  netMargin = 0
  goodWill = false

  constructor(data?: any) {
    super()
    this.updateData(data)
  }

  override updateData(data: any): void {
    if (!data) return
    super.updateData(data)
  }

}

export interface IResAPIGetGeoTreeCountryAndContinent {
  GeoTreeID?: number;
  GeoTreeName?: string;
  ContinentID?: number;
}

export class ResGeoTreeCountryAndContinent extends SafeBaseObject {
  geoTreeID = 0
  geoTreeName = ''
  destinationTypeID = 0
  destinationTypeName = ''
  externalCityID = 0
  externalCity = ''

  constructor(data: any) {
    super();
    this.updateData(data);
  }

}

export class ResBkgProductType extends SafeBaseObject {
  productTypeID = 0
  productTypeName = ''
  isDefault = false

  constructor(data: any) {
    super();
    this.updateData(data);
  }
}

export class ResPassportCountry extends SafeBaseObject {
  countryID = 0
  country = ''
  countryCodISO2 = ''
  countryCod = ''
  countyState = ''

  constructor(data: any) {
    super();
    this.updateData(data);
  }
}

export class ResContinent extends SafeBaseObject {
  geoTreeID = 0;
  geoTreeName = '';

  constructor(data: any) {
    super()
    this.updateData(data)
  }
}

export class ResProperty extends SafeBaseObject {
  propertyID = 0
  productCod = ''
  name = '';
  shortName = '';
  description = '';
  maxOccupancy = 0;
  bedrooms = 0;
  cityID = 0;
  city = '';
  countryID = 0;
  country = '';
  propertyGroup = '';
  propertyGroupID = 0;
  startDate = DateTime.invalid('Empty');
  endDate = DateTime.invalid('Empty');
  webSiteVisibilityFrom = DateTime.invalid('Empty');
  webSiteVisibilityTo = DateTime.invalid('Empty');
  isReservationOpen = false;
  isWebSiteOpen = false;
  status = '';

  constructor(data?: any) {
    super();
    if (data) {
      this.updateData(data);
    }
  }
  override updateData(data: any): void {
    if (!data) return
    super.updateData(data)
    this.addProperty('propertyID', data, 'ID');
  }
}

export interface IResComApiGetPropertiesSearch {
  ID?: number;
  Name?: string;
  City?: string;
  Country?: string;
  ProductCod?: string;
  Status?: string;
  PageSize?: number;
}



export interface IResApiAddAmenities {
  VillaAmenity?: string
  Tier1ID?: number
  Tier2ID?: number
  Tier3ID?: number
  Tier4ID?: number
  PageSize?: number
  IsProductSearch?: string
}

export class ResAdmAmenity extends SafeBaseObject {
  villaAmenityID = 0;
  villaAmenity = '';
  tier = 0;
  order = 0;
  parentID = 0
  // rowCount = 0;

  villaAmenityTier1 = '';
  villaAmenityTier2 = '';
  villaAmenityTier3 = '';

  constructor(data: any) {
    super();
    this.updateData(data);
  }

}

export interface IResApiGetAmenities {
  Tier?: number
  ParentID?: number
  VillaAmenity?: string
}

export class ResAdmAmenityTree extends SafeBaseObject {
  villaAmenityID_1 = 0
  villaAmenity_1 = ''
  tier_1 = 0
  order_1 = 0
  villaAmenityID_2 = 0
  villaAmenity_2 = ''
  tier_2 = 0
  order_2 = 0
  villaAmenityID_3 = 0
  villaAmenity_3 = ''
  tier_3 = 0
  order_3 = 0
  villaAmenityID_4 = 0
  villaAmenity_4 = ''
  tier_4 = 0
  order_4 = 0
  selected = false

  categories: string[] = [];
  category = '';

  constructor(data: any, categories?: any) {
    super();
    this.updateData(data);

    const categoryID = this.getUniqueAmenityID();
    if (categoryID > 0) {
      const filteredCategories = categories?.filter((c: any) => c.VillaAmenityID === categoryID)
      this.categories = filteredCategories?.map((c: any) => c.CategoryCod) ?? [];
      this.category = filteredCategories?.map((c: any) => c.Category).join(', ') ?? '';
    }
  }

  getUniqueAmenityID(): number {
    return Math.max(
      this.villaAmenityID_1,
      this.villaAmenityID_2,
      this.villaAmenityID_3,
      this.villaAmenityID_4
    );
  }

  get key() {
    if (this.villaAmenityID_4 > 0) return this.villaAmenityID_4;
    if (this.villaAmenityID_3 > 0) return this.villaAmenityID_3;
    if (this.villaAmenityID_2 > 0) return this.villaAmenityID_2;
    if (this.villaAmenityID_1 > 0) return this.villaAmenityID_1;
    return 0;
  }

  get displayName(): string {
    if (this.villaAmenityID_4 > 0) return this.villaAmenity_4;
    if (this.villaAmenityID_3 > 0) return this.villaAmenity_3;
    if (this.villaAmenityID_2 > 0) return this.villaAmenity_2;
    if (this.villaAmenityID_1 > 0) return this.villaAmenity_1;
    return '';
  }

}
export interface IResApiAddAmenities {
  VillaAmenity?: string
  Tier1ID?: number
  Tier2ID?: number
  Tier3ID?: number
  Tier4ID?: number
  PageSize?: number
  IsProductSearch?: string
}

export interface IResApiGetAmenities {
  Tier?: number
  ParentID?: number
  VillaAmenity?: string
}

export interface IResApiGetPropertiesLight {
  PropertyID?: number
  Property?: string
  CityID?: number
  Productcod?: string
}

export class ResPropertyLight extends SafeBaseObject {
  productCod = ''
  serviceTypeName = ''
  propertyID = 0
  property = ''
  city = ''
  supplier = ''
  suiteCategories: ResPropertyLightSuiteCategory[] = []

  constructor(data: any) {
    super();
    this.updateData(data);
    if (data?.SuiteCategories) this.suiteCategories = data.SuiteCategories.map((suite: any) => new ResPropertyLightSuiteCategory(suite))
  }
}

export class ResPropertyLightSuiteCategory extends SafeBaseObject {
  suiteCategoryID = 0
  suiteCategory = ''
  suiteCategoryCod = ''
  minPax = 0
  maxPax = 0

  constructor(data: any) {
    super();
    this.updateData(data);
  }
}

export class ResPriceSetupCurrencis extends SafeBaseObject {
  currency = '';

  constructor(data?: any) {
    super();
    this.updateData(data);
  }
}


export class ResRuleType extends SafeBaseObject {
  ruleTypeID = 0
  ruleCode = ''
  ruleType = ''
  isDate = false
  isNumber = false
  isText = false
  dayFlag = false
  monthFlag = false


  constructor(data: any) {
    super();
    this.updateData(data);
  }
}

export interface IResApiManageRule {
  Rules?: IResApiAdmRuleRow[]
}

export interface IResApiAdmRuleRow {
  RuleToItemID?: number
  RuleCode: string
  ExperienceID?: number
  ServiceID?: number
  Value?: number
  Rule?: string
  DateFrom?: DateTime
  DateTo?: DateTime
  StartDate?: DateTime
  EndDate?: DateTime
  MON?: string
  TUE?: string
  WED?: string
  THU?: string
  FRI?: string
  SAT?: string
  SUN?: string
  JAN?: string
  FEB?: string
  MAR?: string
  APR?: string
  MAY?: string
  JUN?: string
  JUL?: string
  AUG?: string
  SEP?: string
  OCT?: string
  NOV?: string
  DEC?: string
  Note?: string
  Status?: string
}

export interface IResApiGetRules {
  ExperienceID?: number
  ServiceID?: number
}

export class ResAdmRules extends SafeBaseObject {
  experienceID = 0
  serviceID = 0
  ruleToItemID = 0
  ruleCode = ''
  ruleType = ''
  value?: number
  rule?: string
  dateFrom = DateTime.invalid('empty')
  dateTo = DateTime.invalid('empty')
  startDate = DateTime.invalid('empty')
  endDate = DateTime.invalid('empty')
  MON = false
  TUE = false
  WED = false
  THU = false
  FRI = false
  SAT = false
  SUN = false
  JAN = false
  FEB = false
  MAR = false
  APR = false
  MAY = false
  JUN = false
  JUL = false
  AUG = false
  SEP = false
  OCT = false
  NOV = false
  DEC = false
  note = ''
  status = 'A'

  constructor(data: any) {
    super();
    this.updateData(data);
  }
}

export interface IResApiGetUniqueSuppliers {
  SupplierUniqueID?: number
  SupplierUniqueName?: string
  IsDMC?: string
}
export class RescomUniqueSuppliers extends SafeBaseObject {
  supplierUniqueID = 0
  supplierUniqueName = ''
  supplierAccountCod = ''
  RFC = ''
  currency = ''
  intercompanyName = ''
  intercompanyID?: number
  status = 'A'
  constructor(data: any) {
    super();
    this.updateData(data);
  }
}

export interface IResApiManageSupplierUnique {
  SupplierUniqueID?: number,
	SupplierUniqueName?: string,
	SupplierAccountCod?: string,
	Currency?: string,
	IntercompanyID?: number,
	RFC?: string,
	Status?: string
}


export interface IResApiManageSupplierUniqueAddresses {
  SupplierUniqueID?: number
	SupplierAddr?: IResApiManageSupplierUniqueAddressesRow[]
}

export interface IResApiManageSupplierUniqueContacts {
  SupplierUniqueID?: number
	SuppCont?: IResApiManageSupplierUniqueContactsRow[]
}


export interface IResApiManageSupplierUniqueAddressesRow {
  SupplierAddressID?: number;
  SupplierID?: number;
  AddressTypeCod?: string;
  Address?: string;
  CityID?: number;
  CountryCod?: string;
  StateCod?: string;
  CountyCod?: string;
  Zip?: string;
  Phone?: string;
  Fax?: string;
  EmergencyPhone?: string;
  Email?: string;
  WebURL?: string;
  Note?: string;
  Status: string;
}

export interface IResApiManageSupplierUniqueContactsRow {
  SupplierContactID?: number;
  SupplierID?: number;
  ContactTypeCod?: string;
  Title?: string;
  FirstName?: string;
  MiddleName?: string;
  LastName?: string;
  JobTitle?: string;
  Department?: string;
  Phone?: string;
  WorkPhone?: string;
  Fax?: string;
  EmergencyPhone?: string;
  Email?: string;
  Note?: string;
  Status: string;
}

export interface IResApiGetPackageUpgradeInventory{
  PackageID?: number;
  PackageTravelDateID?: number;
  PriceTypeID?: number;
  CurrencyCod?: string;
}
export class RescomUpgradeInventory extends SafeBaseObject{
  packageID = 0
  day = 0
  itineraryDate = DateTime.invalid('empty')
  serviceID = 0
  serviceName = ''
  optionID = 0
  optionName = ''
  upgradeOptionID = 0
  upgradeServiceName = ''
  upgradeOptionName = ''
  upgradeAmount = ''
  upgradeCurrency = ''
  totalAvailability = 0
  totalAllocation = 0
  allocationOnQTY = 0
  constructor(data: any) {
    super();
    this.updateData(data);
  }
}
